define( function() {
	"use strict";

	return window.document;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/document.js
// module id = 5
// module chunks = 0